/**
 * 索赔右侧方案展示 赔偿处理 组件（只读）
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React from 'react';
import Lang from "@components/Lang/Lang";
import BtnSelect from '@components/BtnSelect/BtnSelect';
import {symbolMoneyUtil, toFixed2} from '@utils/utils';
import "./claim.less";
/**
 * 索赔右侧方案组件 - 展示已处理的赔偿方案（只读模式）
 * @param {Object} model - 索赔单数据模型
 * @param {Object} values - 表单值对象
 * @param {String} snUit - 单位
 */
const ClaimRightHandle = ({ model = {},  snUit = "PCS" }) => {
    const mgPoInfoVO = model.mgPoInfoVO || {};
    // 回显
    let quantity =0;
    const isBoxClaim = model.isBoxClaim||"0"
    if(isBoxClaim==1){
        quantity= model.wornBoxQuantity * mgPoInfoVO.skuCapacity * mgPoInfoVO.skuCount;
    }else {
        quantity = model.cdQuantity; // wornQuantity
    }
    const refundAmountTotal= toFixed2(mgPoInfoVO.pcsPrice * quantity);
   const values =  {
        claimType:model.claimType,
        isBoxClaim:isBoxClaim,
        // status:model.status,
        quantity: quantity,
        refundAmount: mgPoInfoVO.pcsPrice,
        refundAmountTotal:refundAmountTotal,
        bankCardId:model.bankCardId, // 回显银行卡
    }
    return (
        <div className={"mb_16 bigSize"}>
            {/* 同意赔偿/不同意选择（只读） */}
            {(model.status=="2"||model.status=="3"||model.status=="5")?<div className={"mt_4"}>
                <BtnSelect list={[{
                    code:"2",
                    name:Lang({id:"ShouQuanPeiShen",default:"同意赔偿"})
                },{
                    code:"3",
                    name:Lang({id:"BuTongYi",default:"不同意"})
                }]} initValue={(model.status=="2"||model.status=="5")?"2":"3"}  disabled={true}/>
            </div>:null}
            
            {/* 总赔偿价值/金额 */}
            <div className={"mt_12 flex-item-ver-center"}>
                <span className={"color-red2 mr_2"}>*</span>
                {Lang({id:"ZongPeiChangJiaZhiJinE",default:"总赔偿价值/金额"})}
            </div>
            
            {/* 赔偿方式选择（只读） */}
            {/*<div className={"mt_4"}>*/}
                {/*<BtnSelect list={[{*/}
                    {/*code:"0",*/}
                    {/*name:Lang({id:"AnPoSunShuLiangPeiChang",default:"按破损数量赔偿"})*/}
                {/*},{*/}
                    {/*code:"1",*/}
                    {/*name:Lang({id:"AnZhengXiangPeiChang",default:"按整箱赔偿"})*/}
                {/*}]} initValue={values.isBoxClaim} disabled={true} />*/}
            {/*</div>*/}
            
            {/* 赔偿金额计算展示 */}
            <div className={"flex-item-ver-center"}>
                <div className={"inputAdd"}>
                    {values.quantity}
                </div>
                <div className={"ml_6 font_16 fw_700 color-black"}>{snUit}<span className={"ml_4 mr_4"}>×</span></div>
                {/*{values.refundAmount}*/}
                {symbolMoneyUtil(values.refundAmount,model.mgPoInfoVO&&model.mgPoInfoVO.currencySymbol)}
                <span className={"ml_4 mr_4"}>=</span>
                {/*{values.refundAmountTotal}*/}
                {symbolMoneyUtil(values.refundAmountTotal,model.mgPoInfoVO&&model.mgPoInfoVO.currencySymbol)}
            </div>
            
            {/* 结果说明 */}
            {model&&model.statusMg=="1"?null:<div className={"mt_12"}>
                <div className={"fw_700 black66"}> {Lang({id:"JieGuoShuoMing",default:"结果说明"})}</div>
                <div>{model.cause||"-"}</div>
            </div>}
        </div>
    );
};

export default ClaimRightHandle;

